import {
  //   newsCategories,
  //   home,
  //   news,
  //   documents,
  //   about,
  //   ai,
  //   projects,
  //   contact,
  settings
  //   collections,
  //   pageMap
} from './mock'

export default {
  pageMap: {},
  articleMap: {},
  collections: { articles: {}, documents: {} },
  taxonomies: { newsCategories: { en: {}, fr: {} } },
  content: { home: {}, news: {}, documents: {}, about: {}, ai: {}, projects: {}, contact: {}, settings },
  projectSectorMap: {
    talent: { en: 'Talent', fr: 'Talent' },
    appropriation: { en: 'Appropriation of AI', fr: 'Appropriation de l’IA' },
    concertation: { en: 'Concertation', fr: 'Concertation' },
    strategy: { en: 'Strategy', fr: 'Stratégie' }
  }
}
